import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Symptoms = () => {
  const navigate = useNavigate();
  const [selectedSymptoms, setSelectedSymptoms] = useState([]);

  const symptomOptions = [
    { label: 'Irregular cycles', slug: 'irregular_cycles' },
    { label: 'Hot flashes', slug: 'hot_flashes' },
    { label: 'Night sweats', slug: 'night_sweats' },
    { label: 'Mood changes', slug: 'mood_changes' },
    { label: 'Fatigue', slug: 'fatigue' },
    { label: 'Weight changes', slug: 'weight_changes' },
    { label: 'Sleep issues', slug: 'sleep_issues' },
    { label: 'Low libido', slug: 'low_libido' },
    { label: 'Brain fog', slug: 'brain_fog' },
    { label: 'Anxiety', slug: 'anxiety' }
  ];

  const handleSymptomToggle = (slug) => {
    setSelectedSymptoms(prev =>
      prev.includes(slug)
        ? prev.filter(s => s !== slug)
        : [...prev, slug]
    );
  };

  const handleContinue = () => {
    if (selectedSymptoms.length > 0) {
      const symptomsParam = selectedSymptoms.join(',');
      navigate(`/intake?source=symptoms&symptoms=${symptomsParam}`);
    } else {
      navigate('/intake?source=symptoms');
    }
  };

  return (
    <div className="page-symptoms">
      <div className="symptoms-container">
        <div className="symptoms-card">
          <div className="symptoms-header">
            <h1 className="heading-1">What symptoms are you experiencing?</h1>
            <p className="body-large">
              Select all that apply. This will help us understand your needs better.
            </p>
          </div>

          <div className="symptoms-content">
            <div className="symptoms-grid">
              {symptomOptions.map((symptom) => (
                <label key={symptom.slug} className="symptom-option">
                  <input
                    type="checkbox"
                    checked={selectedSymptoms.includes(symptom.slug)}
                    onChange={() => handleSymptomToggle(symptom.slug)}
                    className="symptom-checkbox"
                  />
                  <span className="symptom-label">{symptom.label}</span>
                </label>
              ))}
            </div>

            <div className="symptoms-actions">
              <button
                onClick={handleContinue}
                className="btn-primary btn-continue"
              >
                Continue to Intake
              </button>
              <p className="body-small symptoms-note">
                You can also skip this and go directly to the intake form
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Symptoms;
